import { gql } from '@apollo/client';

export const GRAPHQL_FRAGMENTS = {
  rangeFields: gql`
    fragment rangeFields on FloatRange {
      min
      max
    }
  `,
  editorialSegmentFields: gql`
    fragment editorialSegmentFields on EditorialSegmentData {
      id
      edmundsTypeCategory
      displayName
      segmentRatings(pagesize: 5, filter: { ratingMode: NEW }) {
        rank
        slugRankedSubmodel
        rankedSubmodel
        modelDisplayOverride
        modelYear {
          id
          makeName
          makeSlug
          modelName
          modelSlug
          year
        }
      }
    }
  `,
  suvSegmentFields: gql`
    fragment suvSegmentFields on EditorialSegmentData {
      id
      edmundsTypeCategory
      displayName
      segmentRatings(pagesize: 1, filter: { ratingMode: NEW }) {
        slugRankedSubmodel
        badges
        modelYear {
          id
          makeName
          makeSlug
          modelName
          modelSlug
          year
          generations {
            generation
            generationYears
          }
        }
      }
    }
  `,
  comparatorSegmentFields: gql`
    fragment comparatorSegmentFields on EditorialSegmentData {
      edmundsTypeCategory
      displayName
      segmentRatings(pagesize: 4, filter: { ratingMode: NEW }) {
        modelYear {
          id
          makeName
          makeSlug
          modelName
          modelSlug
        }
        baseStyleId
      }
    }
  `,
  editorialSegmentFieldsFull: gql`
    fragment editorialSegmentFieldsFull on EditorialSegmentData {
      id
      edmundsTypeCategory
      subsegment
      market
      displayName
      description
      segmentRatings(
        filter: { ratingMode: NEW }
        rankRange: { start: $rankRangeStart, end: $rankRangeEnd }
        pagesize: $pageSize
      ) {
        modelYear {
          id
          makeName
          modelName
          makeSlug
          modelSlug
          year
          publicationStates
          generations {
            generation
            generationYears
          }
        }
        rank
        modelDisplayOverride
        slugRankedSubmodel
        rating
        badges
        note
        priceRange {
          ...rangeFields
        }
        mpgRange {
          ...rangeFields
        }
        edmundsElectricityRange @include(if: $isElectric)
        maxEPAElectricityRange @include(if: $isElectric)
        baseStyleId
      }
    }
  `,
  optionFields: gql`
    fragment optionFields on IOption {
      id
      oemName
      price {
        baseMSRP
        ... on OptionPrice {
          oemDiscountMsrp
        }
      }
      ... on ColorOption {
        colorType
        primaryRGB
      }
      ... on IndividualOption {
        description
      }
    }
  `,
};
